module.exports = __webpack_public_path__ + "static/media/ftn-op-auth.e3f8484d.svg";